class DrawerSearchSection extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.drawerClass = "wt-drawer-search";
    this.drawer = document.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--active`;
    this.classDrawerCollapsed = `${this.drawerClass}--collapsed`;
    this.pageOverlayClass = "search-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;
    // Keep in sync with the curtain transition in custom.css.
    this.curtainDuration = 420;
    this.closeTimer = null;

    this.triggerQuery = [
      ".wt-header__search-trigger",
      ".wt-header__search__close",
      ".search-results__terms",
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);

    // base.js's own nav-drawer triggers: clicks that hand the screen over to the
    // menu, which the dismiss handler below has to close for without animating.
    this.navDrawerTriggerQuery = [
      ".wt-header__menu-trigger",
      ".wt-header__nav-teaser__link--parent",
    ].join(", ");

    // search stuff
    this.cachedResults = {};
    this.input = this.querySelector('input[name="q"]');
    this.clearButton = this.querySelector(".wt-header__search__clear-button");
    this.closeButton = this.querySelector(".wt-header__search__close");
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.searchProperties = this.dataset.searchProperties;

    this.mainTrigger = this.querySelector(".wt-header__search-trigger");
    this.emptyAnnouncement = this.querySelector(".search-empty");
    this.searchResultTop = this.querySelector(".search-result-top");

    this.isVisibleClearButton = false;

    this.saveSuggestionMenuInDesignMode =
      this.saveSuggestionMenuInDesignMode.bind(this);

    this.isPredictiveSearchAvailable = this.hidePredictiveSearch();
    this.isPredictiveSearchEnabled = this.dataset.enablePredictiveSearch === 'true';

    this.setupEventListeners();

    this.toggleTabindexElements = [this.input, this.closeButton];

    // No default suggestions render on open, so this may be absent — guard it.
    const suggestionMenu = this.querySelector(".search-result-top");
    this.suggestionMenuContent = suggestionMenu ? suggestionMenu.cloneNode(true) : null;
    this.timeOut = null;
    this.init();
  }


  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input:not([type='hidden']), select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  // fixOverlayIssue() {
  //     const body = this.body;
  //
  //     if(body.classList.contains(this.activeOverlayBodyClass)) {
  //         const offsetTop = -parseInt(body.style.top);
  //         body.style.position = 'initial';
  //         body.style.top = 'initial';
  //         body.style.left = 'initial';
  //         window.scrollTo(0, offsetTop);
  //
  //     } else {
  //         // body.style.top = -document.documentElement.scrollTop+'px';
  //         // body.style.left = '0px';
  //         // body.style.position = 'fixed';
  //     }
  // }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(this.toggleTabindexElements, "-1");
      setTabindex([this.mainTrigger], "0");
      this.isOpen = false;
      setTimeout(() => {
          this.mainTrigger.focus();
        }, 0);
    } else {
      this.setAttribute("open", "");
      setTabindex(this.toggleTabindexElements, "0");
      setTabindex([this.mainTrigger], "-1");
      this.input.focus();
      this.input.setSelectionRange(
        this.input.value.length,
        this.input.value.length,
      );
      this.isOpen = true;
    }
  }

  toggleDrawerClasses(options) {
    this.onToggle();
    // this.fixOverlayIssue();
    if (this.isOpen) {
      this.openDrawer();
    } else {
      this.closeDrawer(options);
    }
  }

  // The panel's look is entirely CSS (clip-path curtain in custom.css); these
  // two only sequence the classes it keys off.
  // Opening lays the panel out already collapsed, then un-collapses it a frame
  // later — the browser needs the collapsed value committed to a frame first,
  // otherwise it only ever sees the open state and there is nothing to animate.
  openDrawer() {
    clearTimeout(this.closeTimer);
    this.closeNavDrawer();
    this.drawer.classList.add(this.classDrawerActive, this.classDrawerCollapsed);
    this.body.classList.add(this.activeOverlayBodyClass);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.drawer.classList.remove(this.classDrawerCollapsed);
      });
    });
  }

  // Menu and search are mutually exclusive, so opening search shuts the nav
  // drawer first — the mirror of the dismiss handler closing search when the
  // hamburger is pressed.
  // Routed through base.js's own toggleMenu instead of stripping .menu-open
  // here, so aria-expanded, tabindex and open submenus all unwind the way they
  // do on a real hamburger press. That method only ever uses the event for
  // preventDefault and currentTarget, so a minimal stand-in covers it — a real
  // synthetic .click() would bubble to the dismiss handler and immediately shut
  // the panel we're in the middle of opening.
  // No need to suppress the drawer's roll-up: .search-overlay-on drops it to
  // z-index:1 (critical.css) the moment search opens, so it unwinds hidden
  // behind the search panel either way.
  closeNavDrawer() {
    const navDrawer = document.querySelector("drawer-nav");
    // isOpen, not body.menu-open: it's the flag toggleMenu itself branches on,
    // so we can never hand it a state it would read as "closed" and reopen.
    // Also covers the element not being upgraded yet (undefined → falsy).
    if (!navDrawer || !navDrawer.isOpen) return;

    const menuTrigger = document.querySelector(".wt-header__menu-trigger");
    if (!menuTrigger) return;

    navDrawer.toggleMenu({ preventDefault() {}, currentTarget: menuTrigger });
    // Paired with toggleMenu on every real trigger press: both flip the same
    // data-open attribute, so calling one without the other leaves it inverted.
    navDrawer.toggleThirdOptionMenu();
  }

  // Closing runs it in reverse: re-collapse, and only strip the layout classes
  // once the curtain has finished rolling up. Removing them up front (as the
  // old straight toggle did) deleted the fixed-panel layout in the same frame,
  // so there was nothing left on screen to animate out.
  // `immediate` drops both classes synchronously instead, for callers that need
  // the search state gone right now rather than in 0.42s (see the dismiss
  // handler) — same branch also covers reduced-motion, where the transition is
  // off and holding a hidden panel for 0.42s would just be dead time.
  closeDrawer({ immediate = false } = {}) {
    clearTimeout(this.closeTimer);

    if (immediate || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.drawer.classList.remove(this.classDrawerActive, this.classDrawerCollapsed);
      this.body.classList.remove(this.activeOverlayBodyClass);
      return;
    }

    this.drawer.classList.add(this.classDrawerCollapsed);
    this.closeTimer = setTimeout(() => {
      this.drawer.classList.remove(this.classDrawerActive, this.classDrawerCollapsed);
      this.body.classList.remove(this.activeOverlayBodyClass);
    }, this.curtainDuration);
  }

  init() {
    // Backdrop node for the open panel. pageOverlayClass was already reserved
    // here but nothing ever created the element; built the same way base.js
    // builds .menu-drawer-overlay for the nav drawer. Styled in custom.css.
    if (!document.querySelector(`.${this.pageOverlayClass}`)) {
      const overlay = document.createElement("div");
      overlay.classList.add(this.pageOverlayClass);
      this.body.appendChild(overlay);
    }

    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    // Dismiss on any click that isn't the search UI itself — the backdrop, the
    // page behind it, or the header's own search icon. That last one is why
    // this is a catch-all rather than an overlay-only handler: .search-overlay-on
    // sets display:none on .wt-header__search-trigger, so while the panel is
    // open the icon's real trigger isn't hit-testable and the click lands on its
    // wrapper instead — falling through to here is what makes the icon toggle shut.
    document.addEventListener("click", (e) => {
      if (!this.isOpen) return;
      // Clicks the drawer's own listeners already handle (open trigger, close
      // button, result terms) — let those run instead of toggling a second time.
      if (e.target.closest(this.triggerQuery)) return;
      // Anything inside the panel is a search interaction, not a dismissal.
      if (e.target.closest(".wt-header__search__body")) return;
      // Opening the nav menu closes search without the roll-up. critical.css
      // drops .wt-drawer--nav to z-index:1 for as long as .search-overlay-on is
      // set, so animating out would keep the menu pinned behind the search panel
      // for the full 0.42s — its curtain would play invisibly and then pop into
      // view when the class finally dropped. Hand the screen over in one frame.
      this.toggleDrawerClasses({
        immediate: !!e.target.closest(this.navDrawerTriggerQuery),
      });
    });

    this.clearButton.addEventListener("click", () => {
      this.input.value = "";
      this.clearButton.style.display = "none";
      this.isVisibleClearButton = false;
      this.clearResults();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (this.isOpen) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value.length > 0 && !this.isVisibleClearButton) {
        this.clearButton.style.display = "flex";
        this.clearButton.setAttribute("tabindex", "0");
        this.isVisibleClearButton = true;
      } else if (this.input.value.length === 0 && this.isVisibleClearButton) {
        this.clearButton.style.display = "none";
        this.clearButton.setAttribute("tabindex", "-1");
        this.isVisibleClearButton = false;
      }
    });
  }

  hidePredictiveSearch() {
    // when predictive search is not available, we need to hide the predictive search results
    const featuresTag = document.getElementById("shopify-features");
    if (featuresTag) {
      const featuresData = JSON.parse(featuresTag.textContent);
      if (featuresData.predictiveSearch === false) {
        return false;
      }
    }
    return true;
  }

  // search stuff
  setupEventListeners() {
    const form = this.querySelector("form.store-search-form");
    form.addEventListener("submit", this.onFormSubmit.bind(this));
    if (this.isPredictiveSearchAvailable && this.isPredictiveSearchEnabled) {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    if (Shopify.designMode) {
      document.addEventListener(
        "shopify:section:load",
        this.saveSuggestionMenuInDesignMode,
      );
    }
  }

  saveSuggestionMenuInDesignMode() {
    if (this.body.classList.contains(this.activeOverlayBodyClass))
      this.drawer.classList.toggle(this.classDrawerActive);
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (searchTerm.length) {
      this.getSearchResults(searchTerm);
      this.removeAttribute("empty");
    } else {
      this.clearResults();
    }
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,page,article,collection,query&${encodeURIComponent("resources[limit_scope]")}=each&${encodeURIComponent("resources[limit]")}=6&${encodeURIComponent("resources[options][fields]")}=${encodeURIComponent(this.searchProperties)}&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          let error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    this.timeOut = setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        ?.textContent,
    );
  }

  clearResults() {
    this.input.value = "";
    this.removeAttribute("results");
    this.setAttribute("empty", true);
    this.statusElement.innerHTML = this.suggestionMenuContent
      ? this.suggestionMenuContent.innerHTML
      : '';
    // Clear any previous predictive results so clearing the field returns to the bar-only state.
    this.predictiveSearchResults.innerHTML = '';

    clearTimeout(this.timeOut);
    setTimeout(() => {
      this.statusElement.removeAttribute("aria-hidden");
    }, 300);
  }
}

customElements.define("search-drawer", DrawerSearchSection);

/*
 * Products / Collections tab switching for the predictive-search results.
 * Delegated on document because the results markup (sections/predictive-search.liquid)
 * is injected via innerHTML — inline <script> tags in injected HTML never execute,
 * so this must live in a loaded file. Idempotent via the bound flag.
 */
(function () {
  if (window.__searchTabsBound) return;
  window.__searchTabsBound = true;
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".search-tabs__btn");
    if (!btn) return;
    var tabs = btn.closest(".search-tabs");
    if (!tabs) return;
    var name = btn.getAttribute("data-search-tab");
    tabs.querySelectorAll(".search-tabs__btn").forEach(function (b) {
      b.classList.toggle("active", b === btn);
    });
    tabs.querySelectorAll(".search-tabs__panel").forEach(function (p) {
      p.classList.toggle(
        "search-tabs__panel--hidden",
        p.getAttribute("data-search-panel") !== name,
      );
    });
  });
})();

/*
 * Footer "Search" menu link opens the header search panel instead of loading
 * the /search page. The link keeps its real href, so with JS off — or on a
 * header layout that has search switched off — it still navigates normally.
 *
 * Capture phase plus stopPropagation, so the click never reaches the drawer's
 * own document-level dismiss handler (init above). It has to be stopped: the
 * synthetic trigger click below dispatches synchronously, so by the time the
 * original event bubbled back up to that listener it would see an open panel
 * and a target that is neither a trigger nor inside the panel — i.e. a dismiss
 * — and shut what we just opened. The synthetic click itself is safe, since its
 * own target matches triggerQuery and the handler skips those.
 */
(function () {
  if (window.__footerSearchLinkBound) return;
  window.__footerSearchLinkBound = true;

  // Matches the search route under any locale prefix (/search, /en-gb/search)
  // and an explicit data-open-search opt-in for links pointed elsewhere.
  var opensSearch = function (link) {
    if (link.hasAttribute("data-open-search")) return true;
    return /\/search\/?$/.test(link.pathname) && !link.search;
  };

  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest(".wt-footer a[href]");
      if (!link || !opensSearch(link)) return;

      var trigger = document.querySelector(".wt-header__search-trigger");
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      // The panel opens inside the header bar, which is only pinned to the top
      // on sticky-header layouts — from the footer of a non-sticky one it would
      // open offscreen. Jump rather than smooth-scroll: the curtain is 0.42s and
      // an animated scroll would still be travelling while it plays.
      if (trigger.getBoundingClientRect().top < 0) window.scrollTo(0, 0);

      trigger.click();
    },
    true,
  );
})();
